"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderDataGridSelectionCell_unstable", {
    enumerable: true,
    get: function() {
        return renderDataGridSelectionCell_unstable;
    }
});
const _renderTableSelectionCell = require("../TableSelectionCell/renderTableSelectionCell");
const renderDataGridSelectionCell_unstable = (state)=>{
    return (0, _renderTableSelectionCell.renderTableSelectionCell_unstable)(state);
};
